import { render, staticRenderFns } from "./MultiMetricCard.vue?vue&type=template&id=994d58be&scoped=true&"
import script from "./MultiMetricCard.vue?vue&type=script&lang=js&"
export * from "./MultiMetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MultiMetricCard.vue?vue&type=style&index=0&id=994d58be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994d58be",
  null
  
)

export default component.exports